import $ from 'jquery';
import _ from 'underscore';
import screenSize from '../services/screen_size';

export default function () {
    // NOTE: The Youtube code in this file only supports ONE video on the page that makes it autoplay and muted by default.
    // Yes this is very ad hoc, and we should remove this feature once this sponsorship is over. and re strategize on how to implement an overall similar experience across all sponsored collections.
    $(function () {
        const isSponsored = $('.-custom-content').length;
        let $stickyFollowBar = $('.sticky-follow-custom-content-banner').not('.mobile-sticky-custom-content-banner');
        const $window = $(window);
        var player;

        if (screenSize.getSize() === 'small') {
            $stickyFollowBar = $('.mobile-sticky-custom-content-banner');
        }

        function _stickySponsoredBanner() {
            let topNavHeight = $('.nav-bar-wrapper > .ad-wrapper').outerHeight(true);
            const fromTop = $(document).scrollTop();
            const $articleWrapper = $('.article-wrapper');
            const articleWrapperHeight = $articleWrapper.height();
            const headerHeight = $('header').height();
            const $navbarBrands = $('.navbar-brands-container');
            const navbarBrandsHidden = $('.navbar-brands-container').hasClass('fadeOut');

            // Mobile
            if (screenSize.getSize() === 'small') {
                topNavHeight = $('.navbar-brands-container').height();
                if (!$('.navbar-brands-container').hasClass('active')) {
                    $stickyFollowBar.css('top', '60px');
                } else {
                    $stickyFollowBar.css('top', 0);
                }

                if ($articleWrapper.length) {
                    if (fromTop > (articleWrapperHeight + headerHeight)) {
                        $stickyFollowBar.hide();
                    } else {
                        $stickyFollowBar.show();
                    }
                }

                return;
            }

            if (fromTop > topNavHeight) {
                $stickyFollowBar.addClass('stick');


                if (navbarBrandsHidden) {
                    $navbarBrands.hide();
                    $stickyFollowBar.animate({
                        top: 0
                    }, 100);
                } else {
                    $navbarBrands.show();
                }

                if ($articleWrapper.length) {
                    if (fromTop > (articleWrapperHeight + headerHeight)) {
                        $stickyFollowBar.hide();
                    } else {
                        $stickyFollowBar.show();
                    }
                }
            } else {
                $stickyFollowBar.removeClass('stick');
            }
        }

        const $youtubeEmbedEl = $('#custom-content-tile-youtube-embed');
        const youtubeVideoID = $youtubeEmbedEl.data('videoid');
        const embedHeight = $youtubeEmbedEl.data('height');
        const embedWidth = $youtubeEmbedEl.data('width');

        window.onYouTubeIframeAPIReady = function () {
            if (YT) {
                player = new YT.Player('custom-content-tile-youtube-embed', {
                    height: embedHeight,
                    width: embedWidth,
                    autoplay: 1,
                    videoId: youtubeVideoID,
                    events: {
                        onReady: onPlayerReady
                    }
                });
            }
        };

        window.onPlayerReady = function () {
            if (screenSize.getSize() !== 'small') {
                player.mute();
                player.playVideo();
            }
        };

        function setupYoutubeEmbed() {
            let tag = document.createElement('script');
            tag.src = '//www.youtube.com/iframe_api';
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            // 3. This function creates an <iframe> (and YouTube player)
            //    after the API code downloads.
        }

        if (isSponsored) {
            setupYoutubeEmbed();
            $window.on('scroll', _.throttle(_stickySponsoredBanner, 50));
        }
    });
}
